import { render, staticRenderFns } from "./CancelResearch.vue?vue&type=template&id=541b844b"
import script from "./CancelResearch.vue?vue&type=script&lang=js"
export * from "./CancelResearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports